module.exports = require("./scripts/index.js");


//////////////////
// WEBPACK FOOTER
// ./src/feature-hdfc-common-utility/model.xml
// module id = 0
// module chunks = 12